import { render, staticRenderFns } from "./AsRegisterComp.vue?vue&type=template&id=26e285d4&scoped=true"
import script from "./AsRegisterComp.vue?vue&type=script&lang=js"
export * from "./AsRegisterComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e285d4",
  null
  
)

export default component.exports